export default __webpack_public_path__ + "static/media/forward.64c6eb55.png";